import { getExternalConnectionAuthUrl } from '@griply/services';
import { ExternalConnectionsProviders } from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export type GetExternalAuthRedirectedOptions = {
  provider: ExternalConnectionsProviders;
  email?: string;
};

export const getExternalAuthRedirected = async ({
  provider,
  email,
}: GetExternalAuthRedirectedOptions) => {
  const redirectUrl = await getExternalConnectionAuthUrl({
    functions: getFunctions(),
    httpsCallable,
    payload: { provider, ...(email && { email }) },
  });

  window.location.href = redirectUrl;
};
